import LanguageSelect, { TLanguageSelectType } from '../widgets/LanguageSelect';
import { TComponentConfig } from '../types';
import { getMultipleSelectDefaultValueWithSpecialCase } from '../utils';

export const RegionLanguage: TComponentConfig<TLanguageSelectType> = {
  Component: LanguageSelect,
  defaultValue: (filterValue: any, props: TLanguageSelectType) => {
    const { valueKeys: key, options } = props;
    return getMultipleSelectDefaultValueWithSpecialCase(
      filterValue,
      key,
      options,
      [],
    );
  },
  backValue: (filterValue: any, props: TLanguageSelectType) => {
    const key = props.valueKeys;
    const value = filterValue[key];
    const markets = value?.markets || [];

    // 计算所有可用的二级 markets
    const allMarkets: string[] = [];
    (props.options || []).forEach((region: any) => {
      (region.children || []).forEach((child: any) => {
        allMarkets.push(child.value);
      });
    });

    // 全选：返回空数组（去重后比较）
    const uniqueMarkets = Array.from(new Set(markets));
    const uniqueAllMarkets = Array.from(new Set(allMarkets));
    if (
      uniqueMarkets.length === uniqueAllMarkets.length &&
      uniqueMarkets.length > 0
    ) {
      return { [key]: [] };
    }

    // 全不选：返回 ["-99999"]
    if (markets.length === 0) {
      return { [key]: ['-99999'] };
    }

    // 部分选择：返回选中的 markets
    return { [key]: markets };
  },
  condDealwith: (condInfo: any, key: string) => {
    const data = condInfo[key];
    if (!data) return [];

    const localFilterOptions = data.region_language || data || [];

    return (localFilterOptions || []).map(
      ({ region_abbre, region_name_cn, region_name_en, language }: any) => {
        return {
          value: region_abbre?.toLocaleLowerCase?.(),
          text: region_name_en,
          textCN: region_name_cn,
          children: (language || []).map(
            ({ language_en_abbre, language_cn, language_en }: any) => {
              return {
                value: language_en_abbre?.toLocaleLowerCase?.(),
                text: language_en,
                textCN: language_cn,
              };
            },
          ),
        };
      },
    );
  },
  requestKey: 'region_languages',
  props: {
    title: 'Language',
    titleCn: '语言',
    valueKeys: 'languages',
    options: [],
  },
};
